export default __webpack_public_path__ + "static/media/ThaiSansNeue-UltraLight.d065a956.ttf";